module.exports = function getSamplesFromInput (files) {
  const ctx = new (window.AudioContext || window.webkitAudioContext)()
  // Get the ArrayBuffer
  const bufferPromises = files.map( file => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.onload = () => {
          resolve(fileReader.result)
      }
      fileReader.readAsArrayBuffer(file)
    })
  })
  return Promise.all(bufferPromises)
    .then((buffers) => {
      // Turn them into AudioBuffer
      return Promise.all(
        buffers.map(buffer => {
          return new Promise((resolve, reject) => {
            ctx.decodeAudioData(buffer, resolve, reject)
          })
        })
      )
    })
    .then((audioBuffers) => {
      return audioBuffers.map((audioBuffer, i) => {
        let name = files[i].name.split('.')[0]
        return {
          id: `${name}_${Date.now()}`,
          name: name,
          file: new Tone.Player(audioBuffer).toDestination(),
          category: 'loop',
          mySample: true
        }
      })
    })
}
